import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./providers/AuthProvider";
import { DemoProvider } from "./providers/DemoProvider";
import AdminPage from "./pages/admin/AdminPage";
import DashboardHomePage from "./pages/dashboard/DashboardHomePage";
import ChatPage from "./pages/chat/ChatPage";
import IntegrationsPage from "./pages/integrations/IntegrationsPage";
import AutomationsPage from "./pages/automations/AutomationsPage";
import FavoritesPage from "./pages/favorites/FavoritesPage";
import HistoryPage from "./pages/history/HistoryPage";
import TeamPage from "./pages/team/TeamPage";
import PromptSettingsPage from "./pages/prompt-settings/PromptSettingsPage";
import LoginPage from "./pages/login/LoginPage";
import SignupPage from "./pages/signup/SignupPage";
import AcceptInvitePage from "./pages/signup/AcceptInvitePage";
import NotFoundPage from "./pages/NotFoundPage";
import ChartTestsPage from "./pages/chart-tests/ChartTestsPage";
import OAuthTestPage from "./pages/oauth-test/OAuthTestPage";
import DashboardLayout from "./layouts/DashboardLayout";
import "./index.css";

export default () => {
  return (
    <AuthProvider>
      <DemoProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LoginPage />} />
            <Route path="/user-login" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/signup/accept-invite" element={<AcceptInvitePage />} />
            <Route path="/dashboard" element={<DashboardLayout />}>
              <Route index element={<ChatPage />} />
              <Route path="chat" element={<ChatPage />} />
              <Route path="reports" element={<DashboardHomePage />} />
              <Route path="integrations" element={<IntegrationsPage />} />
              <Route path="automations" element={<AutomationsPage />} />
              <Route path="favorites" element={<FavoritesPage />} />
              <Route path="history" element={<HistoryPage />} />
              <Route path="team" element={<TeamPage />} />
              <Route path="prompt-settings" element={<PromptSettingsPage />} />
            </Route>
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/oauth-test" element={<OAuthTestPage />} />
            <Route path="/chart-tests" element={<ChartTestsPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </BrowserRouter>
      </DemoProvider>
    </AuthProvider>
  );
};
